<template>
  <div class="cpt-room-base pt-[17px]">
    <div class="title self-stretch text-tx-1 text-[16px] font-bold leading-[22px] tracking-[0.16px]">基础设置</div>
    <RoomInfo
      class="py-0 relative"
      :form="form"
      :show="show"
      :channels="channels"
      @close="closeSetting"
      @updateSetting="handleUpdateSetting"
    />
    <RoomDefaultSetting
      class="py-0 relative"
      :form="form"
      :show="show"
      :channels="channels"
      @close="closeSetting"
      @updateSetting="handleUpdateSetting"
      @scrollAndHighlight="handleScrollAndHighlight"
    />
  </div>
</template>

<script>
import RoomDefaultSetting from './RoomDefaultSetting.vue';
import RoomInfo from './RoomInfo.vue';
import { getFullChannelList } from '_api/channel';
export default {
  name: 'RoomBase',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    channels: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    RoomInfo,
    RoomDefaultSetting,
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleScroll, true)
  },
  methods: {
    handleUpdateSetting(...args) {
      this.$emit('updateSetting', ...args);
    },
    closeSetting() {
      this.$emit('close');
    },
    handleScrollAndHighlight(selector) {
      const element = this.$el.querySelector(selector)
      if (element) {
        element.scrollIntoView({
          block: 'center',
        })
        this.$nextTick(() => {
          element.classList.add('block-highlight')
          this.highlightElementSelector = selector
          window.addEventListener('click', this.handleCancelHighlight, true)
        })
      }
    },
    handleCancelHighlight() {
      if (this.highlightElementSelector) {
        const element = this.$el.querySelector(this.highlightElementSelector)
        if (element) {
          element.classList.remove('block-highlight')
        }
      }
      window.removeEventListener('click', this.handleCancelHighlight, true)
    }
  },
};
</script>

<style lang="scss">
.cpr-room-base {
  .scroll-item-wrapper {
    padding: 0;
  }
}
.block-highlight {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: -12px;
    bottom: -12px;
    left: -24px;
    right: -24px;
    background: $d-fl-sl;
    pointer-events: none;
  }
}
</style>
